export default __webpack_public_path__ + "static/1172-43293fe32952d987d7d543bb12116320.gif";